import loadable from '@loadable/component';

export const AdminsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "AdminsLinks" */
      './AdminsLinks.dynamic'
    ),
);
